import { __read } from "tslib";
import { useCallback, useState } from 'react';
export var useForceRender = function () {
    var _a = __read(useState({}), 2), updateState = _a[1];
    var forceRender = useCallback(function () { return updateState({}); }, []);
    return forceRender;
};
//# sourceMappingURL=use-force-render.js.map